export default __webpack_public_path__ + "static/media/filter-icon.252a32e5.svg";